import nextRomanceImg from "/img/next-romance.png";
import { Button } from "~/components";
import { useWindowWidth } from "~/utils/hooks/useWindowWidth";

const NextRomance = () => {
  const width = useWindowWidth();

  return (
    <section className="max-md:py-8 py-16" id="next">
      <div className="container">
        <div className="max-md:gap-12 max-md:grid-cols-1 grid grid-cols-2 max-lg:gap-8 items-center">
          <div>
            <div className="max-md:w-full max-md:max-w-full max-w-[475px] mx-auto">
              <h2 className="max-lg:text-4xl max-lg:leading-[49px] text-center text-white text-[48px] font-extrabold leading-[66px]">
                Your Next Romance Awaits
              </h2>
              <div className="max-lg:mt-8 mt-12">
                <Button className="w-full" />
              </div>
            </div>
          </div>
          <div>
            <img
              className="mx-auto max-w-[517px] max-md:max-w-full"
              src={nextRomanceImg}
              alt="Application Preview"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

NextRomance.disolayName = "NextRomance";
export default NextRomance;
